import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { TimesheetService } from '../../service/timesheet.service';
import { AnagraficaTimesheet } from '../../interfaces/timesheet.interface';
import { ElencoRisorseService } from '../../service/elenco-risorse.service';
import { FiltroService } from '../../service/filtro.service';
import { AppService } from '../../service/app.service';
import { TipologicheService } from '../../service/tipologiche.service';
import { ElencoRisorse } from '../../interfaces/elenco-risorse.interface';
import { tipologicaInterface } from '../../interfaces/tipologica.interface';

export const homepageResolver: ResolveFn<{
  anagraficaTimeSheet: AnagraficaTimesheet;
  elencoRisorse: ElencoRisorse[];
  elencoRisorseCount: number;
  commesse: tipologicaInterface[];
  uoPrimoLivello: tipologicaInterface[];
  conteggioCoincidenze: number;
  timesheetApprovati: boolean;
}> = (route, state) => {
  const timesheetService = inject(TimesheetService);
  const elencoRisorseService = inject(ElencoRisorseService);
  const filtroService = inject(FiltroService);
  const appService = inject(AppService);
  const tipologicheService = inject(TipologicheService);
  return filtroService.ultimoFiltroElencoRisorse(appService.attore).pipe(
    switchMap((filtro: any) => {
      return forkJoin({
        anagraficaTimeSheet: timesheetService.getAnagraficaTimeSheet(),
        elencoRisorse: elencoRisorseService.elencoRisorse(filtro),
        elencoRisorseCount: elencoRisorseService.elencoRisorseCount(filtro),
        commesse: tipologicheService.get('commesseDestinazione'),
        uoPrimoLivello: tipologicheService.get('unitaPrimoLivello'),
        conteggioCoincidenze: elencoRisorseService.conteggioCoincidenze(),
        timesheetApprovati: elencoRisorseService.timesheetApprovati()
      });
    })
  );
};

